export function shouldSortOptionsForField(component: any): boolean {
	if (component?.shouldSortOptionsForField && component.shouldSortOptionsForField === true) {
		return true;
	}

	return false;
}
